import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const features = ['30 scripts listos para copiar y pegar (Instagram DM y WhatsApp)', '12 mensajes de follow-up sin vergüenza', 'Plantilla de tracking simple para mejorar semana a semana', 'Paso a paso del Mapa 5F con ejemplos reales', 'Guía de respuestas para objeciones comunes'];
export function OfferSection() {
  return <Section background="cream" className="overflow-hidden" id="oferta" data-id="element-83">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-2 lg:order-1" data-id="element-85">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-8 leading-tight" data-id="element-86">
            Todo lo que incluye el Kit <br data-id="element-87" />
            <span className="text-[#C5A55A] italic" data-id="element-88">'DM Que Cierra'</span>
          </h2>

          <ul className="space-y-4 mb-10" data-id="element-89">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-3" data-id="element-90">
                <div className="mt-1 min-w-[24px] h-6 rounded-full bg-[#C5A55A]/10 flex items-center justify-center text-[#C5A55A]" data-id="element-91">
                  <Check size={14} strokeWidth={3} data-id="element-92" />
                </div>
                <span className="text-[#2D2D2D] text-lg" data-id="element-93">{feature}</span>
              </motion.li>)}
          </ul>

          <Button size="lg" className="w-full md:w-auto shadow-xl" icon href="https://www.mujerdigital2.com/cart/42527848693847:1" data-id="element-94">
            QUIERO EMPEZAR A CERRAR VENTAS
          </Button>

          <div className="flex items-center gap-3 mt-4" data-id="element-95">
            <span className="bg-red-500 text-white text-sm font-bold px-2 py-1 rounded" data-id="element-96">
              -50%
            </span>
            <span className="text-xl md:text-2xl text-[#999] line-through" data-id="element-97">
              $19.980
            </span>
            <span className="text-3xl md:text-4xl font-bold text-[#C5A55A]" data-id="element-98">
              $9.990
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="order-1 lg:order-2 relative" data-id="element-99">
          <div className="absolute inset-0 bg-[#C5A55A] rounded-full opacity-10 blur-3xl transform translate-x-10 translate-y-10" data-id="element-100" />
          <img src="https://cdn.magicpatterns.com/uploads/mrFwVbbMWhQTCogyLvHdf5/heylloyd-image-1770585387001.png" alt="Kit DM Que Cierra Contenido" className="relative z-10 rounded-lg shadow-2xl border-4 border-white w-full max-w-md mx-auto transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-101" />
        </motion.div>
      </div>
    </Section>;
}